module.exports = __webpack_public_path__ + "img/ActionButton.b39b904c.svg";